import React from 'react';
import { useHistory } from 'react-router-dom';

function ReportProcessingPopupComponent({ isOpen, onClose }) {
    const history = useHistory();
    if (!isOpen) return null;

    return (
        <div className="download-popup-overlay">
            <div className="download-popup-container report-processing-popup-container">
                <div className="download-popup-icon-wrap report-processing-popup-icon-wrap">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="64" height="64" rx="32" fill="#ebf0f9" />
                        <path d="M38 20H22C20.8954 20 20 20.8954 20 22V42C20 43.1046 20.8954 44 22 44H42C43.1046 44 44 43.1046 44 42V26L38 20Z" stroke="#2d6cb2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M38 20V26H44" stroke="#2d6cb2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M32 29V37M28 33L32 37L36 33" stroke="#112e53" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h3 className="report-processing-popup-title">Report Processing</h3>
                <p className="report-processing-popup-desc">
                    Your report with attachments is being processed successfully. The files will be available shortly in the <strong>report</strong> folder under <strong>Documents</strong>.
                </p>
                <div className="report-processing-popup-btn-wrap">
                    <button 
                        className="goToDocumentButton" 
                        onClick={() => {
                            onClose();
                            history.push({
                                pathname: '/dependent-documents',
                                state: { openReportFolder: true }
                            });
                        }}
                    >
                        GO TO DOCUMENTS
                    </button>
                    <button 
                        className="download-popup-btn btn-cancel report-processing-popup-btn-full" 
                        onClick={onClose}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ReportProcessingPopupComponent;
